import {
  forwardRef,
  Avatar as ChakraAvatar,
  type AvatarProps as ChakraAvatarProps,
  IconProps,
} from '@chakra-ui/react-v2';
import { OverrideProperties } from 'type-fest';

import { UserIcon } from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';

import { AvatarSize } from './types';

export type AvatarProps = {
  iconProps?: IconProps;
} & OverrideProperties<
  ChakraAvatarProps,
  {
    size?: AvatarSize;
  }
>;

const DEFAULT_ICON_PROPS: IconProps = {
  color: 'page.background',
};

export const Avatar = forwardRef<AvatarProps, 'div'>(
  ({ iconProps, ...restProps }, ref) => (
    <ChakraAvatar
      icon={<UserIcon {...DEFAULT_ICON_PROPS} {...iconProps} />}
      {...restProps}
      ref={ref}
    />
  ),
);
Avatar.displayName = 'Avatar';
